import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TableWidget } from '../../../components/table-widget/TableWidget';
import './deviceActivity.scss';
import axios from 'axios';
import { DnsActivityLayout } from '../../../components/dns-activity/DnsActivityLayout';

export interface Props {
  deviceData: any;
  darkMode?: boolean;
}

export function DeviceActivity(props: Props) {
  const { operatorId, cpeId } = useParams();
  const [params, setParams] = useState<any>();

  async function getDnsGroupDetails(row: any) {
    const params = {
      domain: row.fqdn,
      date: row.time_stamp,
      reason: row.reason,
      profile: row.profile,
      deviceId: props.deviceData?.id,
    };
    setParams(params);
    console.log(params.profile);

    //setShowDnsDetailsModal(true);
  }
  //const timePeriod = watch('timePeriod');

  return (
    <section id="device-dns-tab" className="">
      {props.deviceData?.id && (
        <DnsWidget type={'all'} deviceId={Number([props.deviceData?.id])} haanndleId={cpeId} page={'secondary'} darkMode={props.darkMode} />
      )}
    </section>
  );
}

// Inlined DnsWidget component
const DnsWidget = (props: {
  type: string; // all -> operatorDns  router -> routerDns  device -> deviceDns
  deviceId?: any; // Need for device
  haanndleId?: any; // need for haanndle and device
  page: string; // main -> all three  secondary -> router and device page
  darkMode?: boolean;
}) => {
  const { operatorId } = useParams();
  const { t } = useTranslation();

  const [tableUrl, setTableUrl] = useState<string>();
  const [checkboxSelected, setcheckboxSelected] = useState<string>('1d');
  const [startDateQuery, setStartDateQuery] = useState<string>('');
  const [endDateQuery, setEndDateQuery] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [isAllFilled, setIsAllFilled] = useState<boolean>(false);

  const [deviceSearch, setDeviceSearch] = useState<string>('');
  const [cpeSearch, setCpeSearch] = useState<string>('');
  const [urlSearch, setUrlSearch] = useState<string>('');
  const [accountSearch, setAccountSearch] = useState<string>('');

  const [urlClicked, setUrlClicked] = useState<boolean>(false);

  const [deviceId, setDeviceId] = useState<any>();
  const [cpeId, setCpeId] = useState<any>();

  const [reloadKey, setReloadKey] = useState<number>(0);

  const [clickedMarker, setClickedMarker] = useState();
  const [hideSites, setHideSites] = useState<boolean>(false);

  const [formData, setFormData] = useState<any>({
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
  });

  const [dnsRequests, setDnsRequests] = useState([
    // { allRequests: 0 },
    { allUniqueUrlsVisited: 0 },
    // { allBlockedRequests: 0 },
    { allUniqueUrlsBlocked: 0 },
  ]);

  const [sites, setSites] = useState([
    {
      top3Visited: [
        {
          fqdn: '',
          count: 0,
          reason: '',
          categories: '',
        },
      ],
    },
    {
      top3Blocked: [
        {
          fqdn: '',
          count: 0,
          reason: '',
          categories: '',
        },
      ],
    },
  ]);

  useEffect(() => {
    fetchDnsRequests();
  }, [checkboxSelected]);

  useEffect(() => {
    fetchApi(props.type);
  }, [checkboxSelected, deviceSearch, cpeSearch, hideSites]);

  useEffect(() => {
    fetchApiTimeSearch(props.type);
  }, [formData, deviceSearch, cpeSearch]);

  useEffect(() => {
    const allFilled = Object.values(formData).every((input) => input !== '');
    setIsAllFilled(allFilled);
  }, [formData]);

  const handleMarkerClick = (marker: any) => {
    setHideSites(marker);
  };

  async function fetchDnsRequests() {
    const response = await axios.get(`/v2/op/dns-records/${operatorId}/dns-count/?l=${checkboxSelected}&devId=${props.deviceId}`);
    setDnsRequests(response.data.allDnsRequests);
  }

  async function fetchApi(type: string) {
    setCpeId([]);
    setDeviceId('');

    try {
      if (cpeSearch) {
        setCpeId(Number([cpeSearch]));
        const response = await axios.get(
          `/v2/op/dns-records/${operatorId}/dns-trends/?l=${checkboxSelected}&cpeId=${cpeSearch}&devId=${deviceSearch}`
        );
        setSites(response.data.sites);
      }

      if (deviceSearch) {
        setDeviceId(deviceSearch);
        const response = await axios.get(
          `/v2/op/dns-records/${operatorId}/dns-trends/?l=${checkboxSelected}&cpeId=${cpeSearch}&devId=${deviceSearch}`
        );
        setSites(response.data.sites);
      }

      if (!deviceSearch && !cpeSearch) {
        if (type === 'router') {
          setCpeId(props.haanndleId);
          const response = await axios.get(
            `/v2/op/dns-records/${operatorId}/dns-trends?l=${checkboxSelected}&cpeId=${props.haanndleId}&devId=${
              props.deviceId ? props.deviceId : ''
            }`
          );
          setSites(response.data.sites);
        }

        if (type === 'device') {
          setDeviceId(props.deviceId);
          const response = await axios.get(
            `/v2/op/dns-records/${operatorId}/dns-trends/?l=${checkboxSelected}&cpeId=${props.haanndleId}&devId=${props.deviceId}`
          );
          setSites(response.data.sites);
        }

        if (type === 'all') {
          const response = await axios.get(
            `/v2/op/dns-records/${operatorId}/dns-trends/?l=${checkboxSelected}&cpeId=${cpeSearch}&devId=${deviceSearch}`
          );
          setSites(response.data.sites);
        }
      }

      setTableUrl(tableUrl);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchApiTimeSearch(type: string) {
    if (isAllFilled) {
      let start = formData.startDate + ' ' + formData.startTime + '.000';
      let end = formData.endDate + ' ' + formData.endTime + '.000';

      setStartDateQuery(start);
      setEndDateQuery(end);
      setReloadKey((prevKey) => prevKey + 1);
    }
  }

  const handleCheckboxChange = (value: string) => {
    if (checkboxSelected != value) {
      setHideSites(false);
    
    setUrlClicked(false);
    setcheckboxSelected(value);
    setStartDateQuery('');
    setEndDateQuery('');
    setIsAllFilled(false);
    setReloadKey((prevKey) => prevKey + 1);
    setSelectedRange(value);
  };
  };
  const clearFilter = () => {
    setFormData({
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: '',
    });
  };

  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUrlRowClick = async (row: any) => {
    setUrlSearch(row.key.FQDN);
    setUrlClicked(false);
    setUrlClicked(true);
    setReloadKey((prevKey) => prevKey + 1);
  };

  const handleBackButton = () => {
    setUrlClicked(false);
    setUrlSearch('');
    setReloadKey((prevKey) => prevKey + 1);
  };

  const [selectedRange, setSelectedRange] = useState<string>('1d');

  return (
    <DnsActivityLayout
      darkMode={props.darkMode}
      selectedRange={selectedRange}
      onRangeChange={handleCheckboxChange}
      uniqueVisited={dnsRequests[0]?.allUniqueUrlsVisited}
      uniqueBlocked={dnsRequests[1]?.allUniqueUrlsBlocked}
      hideSites={hideSites}
      showBack={urlClicked}
      onBack={handleBackButton}
      blockedTable={
        <TableWidget
          hasSearch={true}
          url={`v2/op/dns-records/${operatorId}/list-records`}
          countPerPage={5}
          title={t('deviceDetails.activity.uniqueSitesBlocked')}
          searchPositionRight={true}
          hasCategoryFilter={true}
          cpeId={props.haanndleId ? [Number(props.haanndleId)] : []}
          deviceId={props.deviceId ? [Number(props.deviceId)] : []}
          startDate={startDate}
          endDate={endDate}
          isDns={true}
          needCategories={true}
          type={'BLOCKED'}
          urlSearch={urlSearch}
          key={`${urlSearch}-${checkboxSelected}-${props.deviceId}-${props.haanndleId}`}
          onRowSelect={handleUrlRowClick}
          selectedDate={checkboxSelected}
        />
      }
      activityTable={
        <TableWidget
          key={reloadKey}
          hasSearch={true}
          url={`v2/op/dns-records/${operatorId}/list-records`}
          countPerPage={11}
          title={t('deviceDetails.activity.dnsActivity')}
          searchPositionRight={true}
          selectedDate={checkboxSelected}
          startDate={startDate}
          endDate={endDate}
          isDns={true}
          type={urlClicked ? 'TIMESTAMP' : 'DNS'}
          cpeId={props.type === 'router' ? [props.haanndleId] : []}
          deviceId={props.type === 'router' ? [] : [props.deviceId]}
          hasCategoryFilter={true}
          needCategories={true}
          urlSearch={urlClicked ? urlSearch : ''}
          onRowSelect={handleUrlRowClick}
        />
      }
    />
  );
};
